"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingMethodLookup = void 0;
const stringEnum_1 = require("./stringEnum");
exports.ShippingMethodLookup = (0, stringEnum_1.stringEnum)([
    "",
    "USPS.PRIORITY",
    "USPS.EXPRESS.MAIL",
    "USPS.FIRST.CLASS.MAIL",
    "USPS.GROUND.ADVANTAGE",
    "USPS.PARCEL.SELECT.NONPRESORT",
    "USPS.MEDIA.MAIL.SINGLEPIECE",
    "USPS.FIRST.CLASS.MAIL.INTERNATIONAL",
    "USPS.PRIORITY.MAIL.INTERNATIONAL",
    "USPS.EXPRESS.MAIL.INTERNATIONAL",
    "FEDEX.GROUND",
    "FEDEX.GROUND.ECONOMY",
    "FEDEX.HOME.DELIVERY",
    "FEDEX.SMARTPOST.STANDARD",
    "FEDEX.2DAY.SHIPPING",
    "FEDEX.2DAY.AM.SHIPPING",
    "FEDEX.EXPRESS.SAVER.ECONOMY",
    "FEDEX.OVERNIGHT.STANDARD",
    "FEDEX.PRIORITY.OVERNIGHT",
    "FEDEX.INTERNATIONAL.ECONOMY",
    "FEDEX.INTERNATIONAL.PRIORITY",
    "FEDEX.FREIGHT.ECONOMY",
    "UPS.STANDARD",
    "UPS.GROUND",
    "UPS.3.DAY.SELECT",
    "UPS.2ND.DAY.AIR",
    "UPS.2ND.DAY.AIR.AM",
    "UPS.NEXT.DAY.AIR",
    "UPS.NEXT.DAY.AIR.SAVER",
    "UPS.NEXT.DAY.AIR.AM",
    "UPS.MAIL.INNOVATIONS",
    "UPS.SUREPOST",
    "UPS.SUREPOST.LIGHTWEIGHT",
    "UPS.WORLDWIDE.EXPRESS",
    "UPS.WORLDWIDE.EXPRESS.PLUS",
    "UPS.WORLDWIDE.EXPEDITED",
    "DHL.EXPRESS.WORLDWIDE",
    "DHL.PARCEL.EXP.MAX",
    "DHL.PARCEL.PLUS.EXP.MAX",
    "DHL.PARCEL.EXP.MAX.ATL",
    "DHL.PARCEL.PLUS.EXP.MAX.ATL",
    "DHL.PARCEL.EXP.MAX.BWI",
    "DHL.PARCEL.PLUS.EXP.MAX.BWI",
    "DHL.PARCEL.EXP.MAX.CVG",
    "DHL.PARCEL.PLUS.EXP.MAX.CVG",
    "DHL.PARCEL.EXP.MAX.LAX",
    "DHL.PARCEL.PLUS.EXP.MAX.LAX",
    "DHL.PARCEL.EXP.MAX.DFW",
    "DHL.PARCEL.PLUS.EXP.MAX.DFW",
    "DHL.PARCEL.EXP.MAX.ORD",
    "DHL.PARCEL.PLUS.EXP.MAX.ORD",
    "DHL.PARCEL.EXP.MAX.EWR",
    "DHL.PARCEL.PLUS.EXP.MAX.EWR",
    "DHL.PARCEL.EXP.MAX.RDU",
    "DHL.PARCEL.PLUS.EXP.MAX.RDU",
    "DHL.PARCEL.EXP.MAX.SFO",
    "DHL.PARCEL.PLUS.EXP.MAX.SFO",
    "DHL.PARCEL.EXP",
    "DHL.PARCEL.PLUS.EXP",
    "DHL.PARCEL.GROUND",
    "DHL.PARCEL.INTERNATIONAL.DIRECT",
    "DHL.PARCEL.INTERNATIONAL.DIRECT.SMB",
    "DHL.PARCEL.INTERNATIONAL.STANDARD",
    "DHL.PACKET.INTERNATIONAL",
    "DOORDASH.NEXT.DAY",
    "DOORDASH.SAME.DAY",
    "ONTRAC.GROUND",
    "ONTRAC.GROUND.BEN",
    "ONTRAC.GROUND.LAS",
    "ONTRAC.GROUND.LAX",
    "ONTRAC.GROUND.RNO",
    "LASERSHIP.ROUTED.DELIVERY",
    "LASERSHIP.ROUTED.DELIVERY.CLT",
    "LASERSHIP.ROUTED.DELIVERY.MCO",
    "LASERSHIP.ROUTED.DELIVERY.EWR",
    "LASERSHIP.ROUTED.DELIVERY.LCK",
    "LSO.GROUND",
    "LSO.GROUND.DFW",
    "LSO.ECOMM",
    "PCF.STANDARD",
    "PCF.2ND.DAY",
    "AXLEHIRE.NEXT.DAY",
    "FREIGHT.LTL",
    "COURIER.PICKUP",
    "BETTERTRUCKS.SAME.DAY",
    "BETTERTRUCKS.EXPRESS",
    "BETTERTRUCKS.ECONOMY",
    "TFORCE.SAME.DAY",
    "TFORCE.NEXT.DAY",
    "TFORCE.BOND.STANDARD",
    "UDS.DELIVERY.SERVICE",
    "CDL.SAME.DAY",
    "CDL.NEXT.DAY",
    "DELIVERR.SHIPPING",
    "GLS.GROUND",
    "GLS.PRIORITY",
    "GLS.EARLY.PRIORITY",
    "VEHO.NEXT.DAY",
    "VEHO.FLORIDA.NONPRESORT",
    "PITNEYBOWES.PARCEL.SELECT",
    "PASSPORT.PRIORITY.DDU.DELCON",
    "PASSPORT.PRIORITY.DDP.DELCON",
    "PASSPORT.EXPRESS.DDP",
]);
//# sourceMappingURL=ShippingMethod.js.map